export const InformacionInstitucional_item = [
    {
        "InformacionInstitucional_item_nombre" : "DIF Municipales",
        "InformacionInstitucional_item_url" : "DetalleDIFMunicipales"
    },
    {
        "InformacionInstitucional_item_nombre" : "Documentos de Interés",
        "InformacionInstitucional_item_url" : "DocumentosInteres"
    },
    {
        "InformacionInstitucional_item_nombre" : "Identidad Institucional",
        "InformacionInstitucional_item_url" : "Identidad"
    },
    {
        "InformacionInstitucional_item_nombre" : "Informes a DIF Nacional",
        "InformacionInstitucional_item_url" : "InformesSNDIF"
    },
    {
        "InformacionInstitucional_item_nombre" : "Informes a SHCP",
        "InformacionInstitucional_item_url" : "InformesSHCP"
    },
    {
        "InformacionInstitucional_item_nombre" : "Programa Anual de Adquisiciones",
        "InformacionInstitucional_item_url" : "ProgramaAnualAdquisiciones"
    },
    {
        "InformacionInstitucional_item_nombre" : "Programas",
        "InformacionInstitucional_item_url" : "ProgramasDIF"
    }
]